import React from "react";
import { Link, useLocation } from "react-router-dom";

function Footer() {
	const location = useLocation();
	return (
		<footer className="black-bg text-light text-center  padding-bottom-xl  padding-top-xl">
			<div className="container">
				<div className="row">
					<div className="col-md-4">
						<Link to="/">
							<img src="images/Meas-Sol_logo.png" alt="Meas-Sol"/>
						</Link>
					</div>
					<div className="col-md-6">
						<ul className="list-inline">
						      <li className="list-inline-item padding-left-base padding-right-base">
						      		<Link to="/solutions" className={`nav-link ${location.pathname === "/solutions" ? "active" : ""}`}>
									  Solutions
									</Link>
						      </li>
						      <li className="list-inline-item padding-left-base padding-right-base">
						      		<Link to="/usecase" className={`nav-link ${location.pathname === "/usecase" ? "active" : ""}`}>
									  Use Cases
									</Link>
						      </li>
						      <li className="list-inline-item padding-left-base padding-right-base">
						      		<Link to="/aboutus" className={`nav-link ${location.pathname === "/aboutus" ? "active" : ""}`}>
									  About Us
									</Link>
						      </li>
						      <li className="list-inline-item padding-left-base padding-right-base">
						      		<Link to="/contact" className={`nav-link ${location.pathname === "/contact" ? "active" : ""}`}>
									  Contact Us
									</Link>
						      </li>
					    </ul>
					</div>
				</div>
				<p className="padding-top-xl">© {new Date().getFullYear()} Meas-Sol. All Rights Reserved.</p>
			</div>
		</footer>
	);
}

export default Footer;